import axios from 'axios';
import { settings } from '../settings';

export const ListAllTypes = [
  'latest',
  'nieuw_dag',
  'nieuw_week',
  'toppers',
  'top_dag',
  'top_week',
  'top_maand',
  'datum',
  'related',
  'tag',
  'zoek',
  'dumperttv',
  'floppers'];

export const ListType = Object.freeze(ListAllTypes.reduce((a, n) => ({ [n]: n, ...a }), {}));

export const isToppers = typeOfList => typeOfList.startsWith('top');
export const isDateToppers = typeOfList => typeOfList.startsWith('top_');
export const isDateNew = typeOfList => typeOfList.startsWith('nieuw_');
export const isDatePage = typeOfList => typeOfList.startsWith('datum');

export const baseURL = () => axios.create({
  baseURL: `${settings.API_HOST}/mobile_api/json/`,
  timeout: typeof window === 'undefined' ? 2000 : 10000,
});
export const setNsfwHeader = nsfw => axios.defaults.headers.common['X-Dumpert-NSFW'] = nsfw ? '1' : '';

const RATING_API_HOST = settings.API_LEGACY_HOST ? settings.API_LEGACY_HOST : settings.API_HOST;
const CSRF_HEADER = 'X-CSRF-Token';


export const ratingURL = csrf_token => axios.create({
  baseURL: `${RATING_API_HOST}/mobile_api/json/`,
  headers: csrf_token ? { [CSRF_HEADER]: csrf_token }: {},
});

export const loadItem = itemId => baseURL().get(`/info/${itemId}/`, { withCredentials: true });
export const searchLoadItem = itemId => baseURL().get(`/search/${itemId}/0/`, { withCredentials: true });


export const loadItems = ({ type, filter, nsfw, params: { itemId, tagId, sorting, offset, pageNum }, page = 0 }) => {
  const newPage = page === 0 ? '' : page;
  setNsfwHeader(nsfw);

  switch (type) {
  case ListType.tag:
    if (!tagId) {
      throw new Error('tagId must be specified for the list tag');
    }
    return baseURL().get(`/${tagId}/${page}?order=${sorting}`);
  case ListType.zoek:
    if (!tagId) {
      throw new Error('search term must be specified for the list zoek');
    }
    return baseURL().get(`/search/${tagId}/${page}?order=${sorting}`);
  case ListType.dumperttv:
    return baseURL().get('/dumperttv/0/');
  case ListType.related:
    if (!itemId) {
      throw new Error('itemId must be specified for the list related');
    }
    return baseURL().get(`/${type}/${itemId}/`);
  case ListType.latest:
  case ListType.toppers:
    return baseURL().get(`${filter}/${type}/${page}/`);
  case ListType.floppers:
    return baseURL().get(`${filter}/${type}/${page}?order=${sorting}`);
  case ListType.datum:
    return baseURL().get(
      `${filter}/latest/date/${pageNum.split('-')[2]}-${pageNum.split('-')[1]}-${pageNum.split('-')[0]}/`,
    );
  case ListType.nieuw_dag:
  case ListType.nieuw_week:
    return baseURL().get(
      `${filter}/latest/${type.includes('dag') ? 'day' : type.split('_')[1]}/${offset ? `${offset}/` : '0/'}`,
    );
  case ListType.top_dag:
  case ListType.top_week:
  case ListType.top_maand:
    return baseURL().get(`${filter}/top5/${type.split('_')[1]}/${newPage ? `${newPage}/` : '' }`);
  default:
    break;
  }
  throw new Error(`Not supported list type ${type}`);
};

export const setRating = (itemId, value) => {
  const url = `${settings.API_HOST}/mobile_api/json/rating/${itemId}/${value}/`;
  return fetch(url, { mode: 'no-cors' }).then(() => ({ data: { success: true }}));
};

export const setRatingWithCSRF = async (itemId, value) => {
  return settings.API_LEGACY_HOST ?
    await ratingURL().get(`/rating/${itemId}/${value}/`)
    : await ratingURL(
      (await axios.get(`${settings.API_HOST}/csrf_token`, { withCredentials: true })).data.csrf_token,
    ).put(`/rating/${itemId}/${value}/`, null, { withCredentials: true });
};

export const increaseView = itemId => fetch(`${settings.API_HOST}/mobile_api/json/viewed/${itemId}/`, {
  mode: 'no-cors',
});

export const uploadFiles = data => fetch(`${settings.UPLOAD_HOST}/?JSON`, {
  method: 'POST',
  body: data,
});

export const staticURL = () => axios.create({
  baseURL: `${settings.STATIC_FILES_HOST}`,
});

export const loadStoreItems = () => staticURL().get('/winkel.json');

export const submitItemReport = (itemId, data) => axios.put(
  `${settings.API_HOST}/mobile_api/json/report/${itemId}`,
  data,
);

export const submitContactForm = (data) => axios.put(
  `${settings.API_HOST}/mobile_api/json/contactform`,
  data,
  {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  },
);

export const submitTipForm = async data => axios.post(`${settings.COMMENTS_HOST}/api/v1.1/contact/`,
  data,
  {
    headers: {
      'X-CSRF-Token': (await axios.get(
        `${settings.COMMENTS_HOST}/api/v1.1/csrf_token`, { withCredentials: true },
      )).headers['x-csrf-token'],
    },
    withCredentials: true,
  });

export const submitStemForm = data => axios.post(`${settings.API_HOST}/mobile_api/json/stem/topzoveel`,
  data,
  {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    withCredentials: true,
  },
);
